import { ClipboardIcon, UsersIcon } from "@heroicons/react/outline"
import React from "react"
import { toast } from "react-toastify"
import { EndpointConfig } from "../../../config"
import { getCookie } from "../../../helper/auth"
import { axiosInstance } from "../../../lib/axios"
import { Header } from "../../common/header"

export const AdminExisitingUser = () => {
	const [users, setUsers] = React.useState([])

	const [loading, setLoading] = React.useState(false)

	const getUsers = () => {
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			const res = await axiosInstance.get(EndpointConfig.User, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
			setUsers(res.data.users || [])
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	const copyToClipboard = (content) => {
		const el = document.createElement("textarea")
		el.value = content
		document.body.appendChild(el)
		el.select()
		document.execCommand("copy")
		document.body.removeChild(el)
	}

	React.useEffect(() => {
		getUsers()
	}, [])
	return (
		<div className="flex flex-col">
			<Header IconName={UsersIcon} subText={"User"} mainText={"Exisiting User"} />

			<div className="flex flex-col pb-4 overflow-x-auto bg-white rounded">
				{loading ? (
					<div className="w-full p-1 text-sm text-center text-blue-900 pointer-events-none text-bold">
						Loading...
					</div>
				) : (
					<div className="inline-block min-w-full py-2">
						<table className="common">
							<thead className="">
								<tr className="">
									<th className="">Email</th>
									<th className="">Activated On</th>

									<th className="">Actions</th>
								</tr>
							</thead>
							<tbody>
								{users.map((config) => (
									<tr key={config._id}>
										<td className="font-medium">{config.email}</td>
										<td className="font-medium">
											{config.activatedOn
												? new Date(config.activatedOn).toDateString()
												: ""}
										</td>

										<td className="">
											<div className="flex flex-row gap-2">
												{config.inviteToken && (
													<ClipboardIcon
														className="w-4 h-4 text-blue-500 cursor-pointer"
														onClick={() => {
															const baseURL = window.location.origin
															const inviteURL = `${baseURL}/invite?token=${config.inviteToken}`
															copyToClipboard(inviteURL)
															toast(
																"Invite Link - Copied to clipboard"
															)
														}}
													/>
												)}
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</div>
	)
}
